import { SLOTS_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

export interface IBookingDetails {
  booking_id: string;
  booking_status: string;
  is_adjusted: boolean;
  is_charged: boolean;
}
export interface IBookingDetailsResponse {
  massage: string;
  status: boolean;
  data: IBookingDetails | null;
}
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useSendPaymentLinkToUserAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const execute = useCallback(
    async (booking_id: string, mobile_number: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: InventoryTaxCreateAPIResponse = await axios
          .get(`${SLOTS_APIS?.SEND_PAYMENT_LINK?.baseURL}${booking_id}/?mobile=${mobile_number}`, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true && res.data) {
              toast.success("whatsapp send successfully");
              return { status: true, message: "batch" };
            } else {
              toast.error("whatsapp sending failed");
              return { status: false, message: "batch_not_created" };
            }
          })
          .catch((e: AxiosError) => {
            toast.error("whatsapp sending failed");
            if (e.code === "ERR_BAD_REQUEST") {
              return { status: false, message: "batch_not_created" };
            }
            if (e.status === 400) {
              return { status: false, message: "batch_not_created" };
            }
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
